// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-slide.modal .link .img[data-v-09e6cc62]{aspect-ratio:1;border-radius:5%;-o-object-fit:cover;object-fit:cover;width:100%}.swiper-slide-active[data-v-09e6cc62]{opacity:1}.btn-container[data-v-09e6cc62]{background-color:transparent;display:flex;justify-content:space-between;width:100%}.btn-container .btn[data-v-09e6cc62]{background-color:transparent;color:#eee;flex:1;font-size:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
